import React from "react";

const FreshmanHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">Login</a>
            <a href="#freshman-portal">1. Freshman Portal</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>Login</h2>
              <p>
                The login page allows Student/Freshman users to securely sign
                in. Follow these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="freshman-portal" className="section">
              <h2>1. Freshman Portal </h2>

              <h3>1.1 Freshman Dashboard</h3>
              <ul>
                <li>
                  Upon login, a banner will appear: “Freshman Registration
                  Process” with a Setup button.
                </li>
                <li>
                  If the student has not completed the registration process and
                  is not enrolled in any courses, only the banner will be
                  displayed and menu options Notification and Video Tutorial.
                </li>
                <li>
                  If a student is enrolled in one or more courses but
                  registration is not complete, the dashboard will display all
                  course details along with full menu options.
                </li>
                <li>
                  Click Setup button: Redirect to Freshman Registration Process
                  Dashboard.
                </li>
                <li>
                  Notification: Click to open the Notification Page and view all
                  notifications.
                </li>
                <li>
                  Video Tutorial: By clicking redirected to an external page
                  with video instructions for completing the freshman
                  registration process.
                </li>
                <li>
                  Navigation Bar
                  <ul>
                    <li>
                      Email Icon : Clicking this open the mail compose page.
                      Select contact → Enter subject & message → Click Send or
                      Cancel.
                    </li>
                    <li>
                      Notification Icon: Clicking this icon redirects to the
                      Notification Page
                    </li>
                  </ul>
                </li>
                <img
                  src="assets/images/help/freshman_dashboard.png"
                  alt="Freshman dashboard"
                />
              </ul>

              <h2>1.2 Freshman Registration Process</h2>
              <ul>
                <li>Dashboard titled as Freshman Registration process. </li>
                <li>
                  The details of the student like program level, international
                  student and campus will be displayed below the title.
                </li>
                <li>
                  The main steps will appear on the left side of the block, with
                  each step showing its number, title and description. If a step
                  is in progress or enabled, it will also show the percentage of
                  completion.{" "}
                </li>
                <li>
                  By clicking on the main step, the corresponding sub-steps will
                  be displayed on the right side.
                </li>
                <li>
                  Steps in which the student is InProgress will be displayed as
                  default.
                </li>
                <li>
                  The steps and sub steps may be sequential (must complete the
                  current step to unlock the next) or parallel (multiple steps
                  can be completed at the same time), depending upon how the
                  step is setup.
                </li>
                <li>
                  The status of each step will be displayed as "completed," "in
                  progress," "waiting," or "disabled," with color codes: green
                  for completed, blue for in progress, and white for waiting or
                  disabled.
                </li>
                <li>
                  As the completion percentage increases, the step will shift to
                  the left side.
                </li>
                <li>
                  Types of steps
                  <ul>
                    <li>
                      Some sub-steps will take you to another website or page
                      when clicked. Once completed, progress will be
                      automatically updated, and the step will move to the left
                      side of the block.
                    </li>
                    <li>
                      Steps progress can be updated manually by entering the
                      percentage. Setting it to 100% may or may not require
                      admin approval, depending on the step setup.
                      <ul>
                        <li>
                          If approval is required, a request sent to admin for
                          approval. If approved, the step is marked done; if
                          rejected, the percentage resets to 0 and needs to be
                          updated again.
                        </li>
                        <li>
                          If approval is not required, the student can continue
                          to the next step without waiting.
                        </li>
                                        <img
                  src="assets/images/help/freshman_process.png"
                  alt="Freshman process"
                />
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreshmanHelpInstructions;
